module.exports = __webpack_public_path__ + "media/img/students-cap-cdd77513ad831bbd989e45ac7cc294ea.svg";